/*
 * Configuration for all levels.
 */
var levels = (module.exports = {});

levels.custom = {};
